exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!github-markdown-css/github-markdown.css"), "");

// module
exports.push([module.id, "\n.about[data-v-0f7d8fd0] {\n  padding: 2% 5%;\n}\n", ""]);

// exports
